import gql from 'graphql-tag'
export default gql`
  query MasterTypes($limit: Int, $offset: Int, $filters: [Filter]) {
    MasterTypes: FilmMasters(noCache: true, limit: $limit, offset: $offset, filters: $filters) {
      id
      filmID
      ViLabels(distinct: "type") {
        type
        CountViGroup {
          filmMasterID
          type
          countRows
        }
      }
    }
  }
  `
